import { render, staticRenderFns } from "./recoverpassword.vue?vue&type=template&id=5e843a58"
import script from "./recoverpassword.vue?vue&type=script&lang=js"
export * from "./recoverpassword.vue?vue&type=script&lang=js"
import style0 from "./recoverpassword.vue?vue&type=style&index=0&id=5e843a58&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports